import {Component, EventEmitter, Input, Output} from '@angular/core';
import {VehicleBrand} from '../../../../domain/core/vehicle-brand.model';
import {CheckboxIconComponent} from '../../../../shared/components/checkbox-icon/checkbox-icon.component';
import {ContactEventsComponent} from '../contact-events/contact-events.component';
import {ContactChannelsComponent} from '../contact-channels/contact-channels.component';
import {CustomerClientRequest} from '../../../../domain/data/customer-client-request.data';
import {CustomerClientResponse} from '../../../../domain/data/customer-client-response.data';
import {ConsentStatus} from '../../../../domain/data/consent-status';

@Component({
    selector: 'app-communication',
    imports: [
        CheckboxIconComponent,
        ContactEventsComponent,
        ContactChannelsComponent,
    ],
    templateUrl: './communication.component.html'
})
export class CommunicationComponent {
  @Input() brand: VehicleBrand
  @Input() customerConsentRequest: CustomerClientRequest;
  @Input() customerConsentResponse: CustomerClientResponse;
  @Input() descriptionText: string;
  @Output() contactEventChanged = new EventEmitter<void>();
  @Output() contactChannelChanged = new EventEmitter<void>();

  textExpanded = false;

  protected readonly ConsentStatus = ConsentStatus;

  handleContactEventChanged() {
    this.contactEventChanged.emit();
  }

  handleContactChannelChanged() {
    this.contactChannelChanged.emit();
  }

  getCommunicationIcon(icon: 'checked' | 'unchecked'): string {
    const iconMappings = {
      checked: {
        condition: this.atLeastOneContactEventConfirmed() && this.atLeastOneContactChannelConfirmed(),
        true: 'box-checked-green',
        false: 'box-checked-grey'
      },
      unchecked: {
        condition: this.areAllContactCheckboxesWithdrawn(),
        true: 'box-unchecked-red',
        false: 'box-unchecked-grey'
      }
    };

    const mapping = iconMappings[icon];
    return mapping ? (mapping.condition ? mapping.true : mapping.false) : undefined;
  }

  atLeastOneContactEventConfirmed() {
    return this.customerConsentRequest?.offers === ConsentStatus.CONFIRMED
      || this.customerConsentRequest?.reminder === ConsentStatus.CONFIRMED
      || this.customerConsentRequest?.surveys === ConsentStatus.CONFIRMED
      || this.customerConsentRequest?.events === ConsentStatus.CONFIRMED;
  }

  atLeastOneContactChannelConfirmed() {
    return this.customerConsentRequest?.messenger === ConsentStatus.CONFIRMED
      || this.customerConsentRequest?.email === ConsentStatus.CONFIRMED
      || this.customerConsentRequest?.phone === ConsentStatus.CONFIRMED
      || this.customerConsentRequest?.post === ConsentStatus.CONFIRMED;
  }

  areAllContactCheckboxesWithdrawn(): boolean {
    const channelCheck = this.customerConsentRequest?.messenger === ConsentStatus.WITHDRAWN
      && this.customerConsentRequest?.email === ConsentStatus.WITHDRAWN
      && this.customerConsentRequest?.phone === ConsentStatus.WITHDRAWN
      && this.customerConsentRequest?.post === ConsentStatus.WITHDRAWN;

    const eventCheck = this.customerConsentRequest?.offers === ConsentStatus.WITHDRAWN
      && this.customerConsentRequest?.reminder === ConsentStatus.WITHDRAWN
      && this.customerConsentRequest?.surveys === ConsentStatus.WITHDRAWN
      && this.customerConsentRequest?.events === ConsentStatus.WITHDRAWN;

    return channelCheck && eventCheck;
  }

  setValueForAllContacts(value: ConsentStatus) {
    this.customerConsentRequest.messenger = value;
    this.customerConsentRequest.email = value;
    this.customerConsentRequest.phone = value;
    this.customerConsentRequest.post = value;
    this.customerConsentRequest.offers = value;
    this.customerConsentRequest.reminder = value;
    this.customerConsentRequest.surveys = value;
    this.customerConsentRequest.events = value;

    this.handleContactChannelChanged();
    this.handleContactEventChanged();
  }

  toggleExpand() {
    this.textExpanded = !this.textExpanded;
  }
}
